module.exports = __webpack_public_path__ + "static/media/project-5.a6af5042.jpg";